<template>
  <main id="authorBBook" v-if="config.status.authed">
    <Navigator ref="navigator"
      :books="getBookMetaItems"
      @emit="emitted"
    />
    <Toolbars
      ref="toolbars"
      :status="getStatus"
      @emit="emitted"
    />
    <!-- <div id="legacy">
      <iframe name="legacyFrame" src=""></iframe>
      <form id="legacyForm" ref="legacyForm" target="legacyFrame" action="https://legacy.sasmango.com/sas/author/bbook?type=bank" method="POST">
        <input type="hidden" name="firebaseToken" ref="legacyToken" value="" />
      </form>
    </div> -->
    <v-list dense class="py-0 transparent clients body" :three-line="!$vuetify.breakpoint.smAndUp">
      <v-list-item class="px-0 mx-3" v-if="$vuetify.breakpoint.smAndUp">
        <v-row v-if="$refs.navigator && $refs.navigator.getTabSlug === 'card'">
          <v-col :class="['primary text-center font-weight-black blue-grey--text text--darken-3 px-1', { caption: $vuetify.breakpoint.lgAndUp }]">利用日</v-col>
          <v-col :class="['primary text-center font-weight-black blue-grey--text text--darken-3 px-1', { caption: $vuetify.breakpoint.lgAndUp }]">顧客名</v-col>
          <v-col :class="['primary text-center font-weight-black blue-grey--text text--darken-3 px-1', { caption: $vuetify.breakpoint.lgAndUp }]">勘定科目</v-col>
          <v-col :class="['primary text-center font-weight-black blue-grey--text text--darken-3 px-1', { caption: $vuetify.breakpoint.lgAndUp }]">利用内容</v-col>
          <v-col :class="['primary text-center font-weight-black blue-grey--text text--darken-3 px-1', { caption: $vuetify.breakpoint.lgAndUp }]">利用額</v-col>
        </v-row>
        <v-row v-else>
          <v-col :class="['primary text-center font-weight-black blue-grey--text text--darken-3 px-1', { caption: $vuetify.breakpoint.lgAndUp }]">取引日</v-col>
          <v-col :class="['primary text-center font-weight-black blue-grey--text text--darken-3 px-1', { caption: $vuetify.breakpoint.lgAndUp }]">引出し額</v-col>
          <v-col :class="['primary text-center font-weight-black blue-grey--text text--darken-3 px-1', { caption: $vuetify.breakpoint.lgAndUp }]">預入れ額</v-col>
          <v-col :class="['primary text-center font-weight-black blue-grey--text text--darken-3 px-1', { caption: $vuetify.breakpoint.lgAndUp }]">取引先</v-col>
          <v-col :class="['primary text-center font-weight-black blue-grey--text text--darken-3 px-1', { caption: $vuetify.breakpoint.lgAndUp }]">勘定項目</v-col>
        </v-row>
      </v-list-item>
      <v-progress-linear indeterminate :color="isLoading ? 'secondary' : 'transparent'" />
      <template v-for="item in getItems">
        <v-list-item
          v-if="$refs.navigator && $refs.navigator.getTabSlug === 'card'"
          class="px-0 it-hv mx-3"
          :key="item.id"
          :data-id="item.id">
          <v-row v-if="$vuetify.breakpoint.smAndUp">
            <v-col :class="['text-center text-truncate', { caption: $vuetify.breakpoint.lgAndUp }]">{{ item.date }}</v-col>
            <v-col :class="['text-center text-truncate', { caption: $vuetify.breakpoint.lgAndUp }]">{{ item.client }}</v-col>
            <v-col :class="['text-center text-truncate', { caption: $vuetify.breakpoint.lgAndUp }]">{{ item.label }}</v-col>
            <v-col :class="['text-center text-truncate', { caption: $vuetify.breakpoint.lgAndUp }]">{{ item.item }}</v-col>
            <v-col :class="['text-right text-truncate', { caption: $vuetify.breakpoint.lgAndUp }]">{{ item.sum }}</v-col>
          </v-row>
          <v-list-item-content v-else>
            <v-list-item-subtitle class="caption">{{ `${item.item}/${item.deposite}` }}</v-list-item-subtitle>
            <v-list-item-subtitle>{{ item.withdraw }}</v-list-item-subtitle>
            <v-list-item-title class="body-1">
              <span class="font-weight-bold">未：</span><span>{{ item.client }}</span>
              <span class="font-weight-bold ml-2">済：</span><span>{{ item.label }}</span>
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item
          v-else
          class="px-0 it-hv mx-3"
          :key="item.id"
          :data-id="item.id">
          <v-row v-if="$vuetify.breakpoint.smAndUp">
            <v-col :class="['text-center text-truncate', { caption: $vuetify.breakpoint.lgAndUp }]">{{ item.date }}</v-col>
            <v-col :class="['text-right text-truncate', { caption: $vuetify.breakpoint.lgAndUp }]">{{ item.withdraw }}</v-col>
            <v-col :class="['text-right text-truncate', { caption: $vuetify.breakpoint.lgAndUp }]">{{ item.deposite }}</v-col>
            <v-col :class="['text-center text-truncate', { caption: $vuetify.breakpoint.lgAndUp }]">{{ item.client }}</v-col>
            <v-col :class="['text-center text-truncate', { caption: $vuetify.breakpoint.lgAndUp }]">{{ item.label }}</v-col>
          </v-row>
          <v-list-item-content v-else>
            <v-list-item-subtitle class="caption">{{ `${item.item}/${item.deposite}` }}</v-list-item-subtitle>
            <v-list-item-subtitle>{{ item.withdraw }}</v-list-item-subtitle>
            <v-list-item-title class="body-1">
              <span class="font-weight-bold">未：</span><span>{{ item.client }}</span>
              <span class="font-weight-bold ml-2">済：</span><span>{{ item.label }}</span>
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-divider :key="item.id + '_div'"></v-divider>
      </template>
    </v-list>
    <UploadModal ref="uploader" :books="getBookMetaItems" />
  </main>
</template>

<script>
import Toolbars from './toolbars'
import Navigator from './navigator'
import UploadModal from './modals/upload'
const DEF = {
  LOADING: false,
  FILTERED: false,
  LIMIT: 20,
  ORDER: {
    FIELD: 'date',
    DIR: 'desc'
  }
}
const ICONS = {
  ORDER: {
    DIR: {
      ASC: ['fal', 'sort-numeric-down'],
      DESC: ['fal', 'sort-numeric-up']
    }
  }
}
export default {
  name: 'authorBBook',
  components: {
    Toolbars,
    Navigator,
    UploadModal
  },
  data () {
    return {
      config: {
        status: {
          authed: false,
          loading: DEF.LOADING
        }
      },
      meta: {
        withdraws: [ 'payments', 'prefunds' ],
        books: {
          bank: {
            mitsuisumitomo: {
              bid: '106011626118',
              label: '三井住友銀行'
            },
            rakuten: {
              bid: '106012926744',
              label: '楽天銀行'
            }
          },
          card: {
            dc: {
              bid: '106011962318',
              label: 'DCカード'
            },
            life: {
              bid: '106911509370',
              label: 'LIFEMASTER'
            }
          }
        },
        labels: {
          deposites: '預り金',
          payments: '預り金',
          commissions: '預り金',
          prefunds: '預り金（返金）',
          drefunds: '預り金（返金）',
          dcpayments: '預り金',
          dcrefunds: '預り金（返金）'
        },
        items: {
          school: '学費',
          stay: '滞在費用',
          aviation: '航空券代金',
          avicom: '航空券変更手数料',
          insurance: '保険料',
          visa: '査証費用',
          domestic: '国内諸経費',
          hotel: 'ホテル代',
          apart: 'アパート代',
          support: '現地サポート代',
          test: 'テスト受験代',
          mobile: '携帯電話代',
          computer: 'パソコン代',
          examfee: '受験料',
          textfee: '参考書代',
          hospital: '病院診察代金',
          tour: '現地ツアー代',
          traffic: '現地交通代',
          shipping: '現地荷物発送費',
          uniform: '制服・スーツ代',
          carry: '繰越金',
          bank_handling: '銀行手数料'
        }
      },
      store: {
        items: [],
        clients: {}
      },
      form: {
        order: {
          field: DEF.ORDER.FIELD,
          dir: DEF.ORDER.DIR,
          icon: ICONS.ORDER.DIR[DEF.ORDER.DIR.toUpperCase()]
        }
      },
    }
  },
  created () {
    this.init()
  },
  methods: {
    init: function () {
      this.auth()
      this.$nextTick(() => {
        // this.loadLegacy()
      })
    },
    emitted: function (req) {
      const { dest, action, data } = req
      if (dest && this.$refs[dest] && typeof this.$refs[dest][action] === 'function') {
        this.$refs[dest][action](data)
      } else if (typeof this[action] === 'function') {
        this[action](data)
      }
    },
    auth: function () {
      let auths = this.$store.getters['author/get']('authority')
      let permit = this.$route.meta.permit
      if (!auths.includes(permit)) {
        this.$router.push('/')
      } else {
        this.$set(this.config.status, 'authed', true)
      }
    },
    get: function (fm) {
      if (fm) {
        console.log(fm)
        this.$set(this.config.status, 'loading', true)
        this.$firebase.auth().currentUser.getIdToken(true).then(token => {
          this.axios.post(`${this.$url.api}bbook/get/items`, {
            form: {
              date: fm.date,
              area: fm.area,
              status: fm.status,
              type: fm.type,
              gid: fm.gid
            },
            limit: {
              offset: fm.limit.offset,
              size: fm.limit.size
            },
            order: {
              field: this.form.order.field,
              dir: this.form.order.dir
            }
          }, {
            headers: {
              'firebase-token': token
            }
          }).then(res => {
            console.log(res)
            if (res.data && res.data.success) {
              const { items, clients, count } = res.data.data
              this.$set(this.store, 'items', items)
              this.$set(this.store, 'clients', clients)
              this.$refs.toolbars.count(count)
            }
            this.$set(this.config.status, 'loading', false)
          })
        })
      }
    },
    upload: function (req) {
      if (this.$refs.uploader) {
        this.$refs.uploader.open(req)
      }
    },
    loadLegacy: function () {
      this.$firebase.auth().currentUser.getIdToken(true).then(token => {
        this.$refs.legacyToken.value = token
        this.$nextTick(() => {
          this.$refs.legacyForm.submit()
        })
      })
    }
  },
  computed: {
    isAuthed () {
      return this.config.status.authed
    },
    isLoading () {
      return this.config.status.loading
    },
    getStatus () {
      return this.config.status
    },
    getBookMetaItems () {
      return this.meta.books
    },
    getItems () {
      return this.store.items.length ? this.store.items.map(it => {
        const { id, cid, date, type, sum, label } = it
        const client = this.store.clients[cid]
        return {
          id,
          date: this.$moment(date).format('YYYY/MM/DD'),
          withdraw: this.meta.withdraws.includes(type) ? `¥${`${sum}`.replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1,')}` : '',
          deposite: !this.meta.withdraws.includes(type) ? `¥${`${sum}`.replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1,')}` : '',
          client: client.name.replace(',', ' '),
          label: this.meta.labels[type] || '',
          sum: `¥${`${sum}`.replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1,')}`,
          item: this.meta.items[label]
        }
      }) : []
    }
  }
}
</script>

<style lang="scss">
#authorBBook {
  #legacy {
    width: 100%;
    height: 100%;
    iframe {
      display: block;
      width: 100%;
      height: 100%;
      border: none;
    }
  }
}
</style>
